/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils


/* ++++++++++ --------------- EXPORTS : PAYMENT: STYLES --------------- ++++++++++ */
export default theme =>({
  payment: {
    '& .sectioncard': {
      padding: 0,
      '& > div': {
        opacity: '0',
        animationName: 'fadeInUp',
        animationDuration: '.2s',
        animationFillMode: 'forwards',
        animationDelay: '.15s',
        display: 'flex',
        flexDirection:'column'
      }
    },
    '& .emptystate': {
      padding: replacePXinStringWithEM('40px 40px 60px'),
    },
    '& .button': {
      height: pxToEm(32),
      maxWidth: pxToEm(180),
      padding: replacePXinStringWithEM('0 16px'),
      '& .text': {
        fontSize: pxToEm(14)
      }
    }
  }
});
